export const API_KEYS_DETAIL = `
    _id
    name
    description
    valid_from
    valid_to
    status
`;